const { createReducer } = require("../../helpers");
const {
  CREATE_TRANSACTION,
  CREATE_TRANSACTION_SUCCESS,
  CREATE_TRANSACTION_ERROR,
  CREATE_TRANSACTION_RESET,

  GET_INVOICE,
  GET_INVOICE_SUCCESS,
  GET_INVOICE_ERROR,
  GET_INVOICE_RESET,

  GET_TRANSACTIONS,
  GET_TRANSACTIONS_SUCCESS,
  GET_TRANSACTIONS_ERROR,
  GET_TRANSACTIONS_RESET,

  GET_TRANSACTION,
  GET_TRANSACTION_SUCCESS,
  GET_TRANSACTION_ERROR,
  GET_TRANSACTION_RESET,

  UPDATE_ADDRESS,
  UPDATE_ADDRESS_SUCCESS,
  UPDATE_ADDRESS_ERROR,
  UPDATE_ADDRESS_RESET,

  CART_CHECKOUT,
  CART_CHECKOUT_SUCCESS,
  CART_CHECKOUT_ERROR,
  CART_CHECKOUT_RESET,

  TRANSACTION_DELIVERY,
  TRANSACTION_DELIVERY_SUCCESS,
  TRANSACTION_DELIVERY_ERROR,
  TRANSACTION_DELIVERY_RESET,

  DELIVERY_PRICELIST,
  DELIVERY_PRICELIST_SUCCESS,
  DELIVERY_PRICELIST_ERROR,
  DELIVERY_PRICELIST_RESET,

  DELIVERY_LIST_PROVIDERS,
  DELIVERY_LIST_PROVIDERS_SUCCESS,
  DELIVERY_LIST_PROVIDERS_ERROR,
  DELIVERY_LIST_PROVIDERS_RESET,
} = require("./constants");

const initialState = {
  create: {
    data: {},
    loading: false,
    error: false,
  },
  invoice: {
    data: {},
    loading: false,
    error: false,
  },
  transactions: {
    data: [],
    loading: false,
    error: false,
  },
  transaction: {
    data: {},
    loading: false,
    error: false,
  },
  update: {
    data: {},
    loading: false,
    error: false,
  },
  checkout: {
    data: {},
    loading: false,
    error: false,
  },
  deliveryPriceList: {
    data: {},
    loading: false,
    error: false,
  },
  deliveryProvidersList: {
    data: {},
    loading: false,
    error: false,
  },
};

module.exports = createReducer(
  {
    /// ----------------------CREATE TRANSACTION---------------------------///
    [CREATE_TRANSACTION]: (draft) => ({
      create: {
        ...draft.create,
        loading: true,
      },
    }),
    [CREATE_TRANSACTION_SUCCESS]: (draft, action) => ({
      create: {
        ...draft.create,
        loading: false,
        data: action.payload.transaction,
      },
    }),
    [CREATE_TRANSACTION_ERROR]: (draft, action) => ({
      create: {
        ...draft.create,
        loading: false,
        error: action.payload.error,
      },
    }),
    [CREATE_TRANSACTION_RESET]: () => ({
      create: { ...initialState.create },
    }),
    /// ----------------------GET INVOICE-------------------------///
    [GET_INVOICE]: (draft) => ({
      invoice: {
        ...draft.invoice,
        loading: true,
      },
    }),
    [GET_INVOICE_SUCCESS]: (draft, action) => ({
      invoice: {
        ...draft.invoice,
        loading: false,
        data: action.payload.html,
      },
    }),
    [GET_INVOICE_ERROR]: (draft, action) => ({
      invoice: {
        ...draft.invoice,
        loading: false,
        error: action.payload.error,
      },
    }),
    [GET_INVOICE_RESET]: () => ({
      invoice: { ...initialState.invoice },
    }),
    /// ----------------------GET TRANSACTIONS-------------------------///
    [GET_TRANSACTIONS]: (draft) => ({
      transactions: {
        ...draft.transactions,
        loading: true,
      },
    }),
    [GET_TRANSACTIONS_SUCCESS]: (draft, action) => ({
      transactions: {
        ...draft.transactions,
        loading: false,
        data: action.payload.transaction,
      },
    }),
    [GET_TRANSACTIONS_ERROR]: (draft, action) => ({
      transactions: {
        ...draft.transactions,
        loading: false,
        error: action.payload.error,
      },
    }),
    [GET_TRANSACTIONS_RESET]: () => ({
      transactions: { ...initialState.transactions },
    }),
    /// ----------------------GET TRANSACTION-------------------------///
    [GET_TRANSACTION]: (draft) => ({
      transaction: {
        ...draft.transaction,
        loading: true,
      },
    }),
    [GET_TRANSACTION_SUCCESS]: (draft, action) => ({
      transaction: {
        ...draft.transaction,
        loading: false,
        data: action.payload.transaction,
      },
    }),
    [GET_TRANSACTION_ERROR]: (draft, action) => ({
      transaction: {
        ...draft.transaction,
        loading: false,
        error: action.payload.error,
      },
    }),
    [GET_TRANSACTION_RESET]: () => ({
      transaction: { ...initialState.transaction },
    }),
    /// -----------------------UPDATE ADDRESS-----------------------///
    [UPDATE_ADDRESS]: (draft) => ({
      update: {
        ...draft.update,
        loading: true,
      },
    }),
    [UPDATE_ADDRESS_SUCCESS]: (draft, action) => ({
      update: {
        ...draft.update,
        loading: false,
        data: action.payload.address,
      },
    }),
    [UPDATE_ADDRESS_ERROR]: (draft, action) => ({
      update: {
        ...draft.update,
        loading: false,
        error: action.payload.error,
      },
    }),
    [UPDATE_ADDRESS_RESET]: () => ({
      update: { ...initialState.update },
    }),
    /// -----------------------CART CHECKOUT-----------------------///
    [CART_CHECKOUT]: (draft) => ({
      checkout: {
        ...draft.checkout,
        loading: true,
      },
    }),
    [CART_CHECKOUT_SUCCESS]: (draft, action) => ({
      checkout: {
        ...draft.checkout,
        loading: false,
        data: action.payload.transaction,
      },
    }),
    [CART_CHECKOUT_ERROR]: (draft, action) => ({
      checkout: {
        ...draft.checkout,
        loading: false,
        error: action.payload.error,
      },
    }),
    [CART_CHECKOUT_RESET]: () => ({
      checkout: { ...initialState.checkout },
    }),

    /// -----------------------CART CHECKOUT-----------------------///
    [TRANSACTION_DELIVERY]: (draft) => ({
      transaction: {
        ...draft.transaction,
        loading: true,
      },
    }),
    [TRANSACTION_DELIVERY_SUCCESS]: (draft, action) => ({
      transaction: {
        ...draft.transaction,
        loading: false,
        data: action.payload.data,
      },
    }),
    [TRANSACTION_DELIVERY_ERROR]: (draft, action) => ({
      transaction: {
        ...draft.transaction,
        loading: false,
        error: action.payload.error,
      },
    }),
    [TRANSACTION_DELIVERY_RESET]: () => ({
      transaction: { ...initialState.transaction },
    }),

    /// -----------------------CART CHECKOUT-----------------------///
    [DELIVERY_PRICELIST]: (draft) => ({
      deliveryPriceList: {
        ...draft.deliveryPriceList,
        loading: true,
      },
    }),
    [DELIVERY_PRICELIST_SUCCESS]: (draft, action) => ({
      deliveryPriceList: {
        ...draft.deliveryPriceList,
        loading: false,
        data: action.payload.data,
      },
    }),
    [DELIVERY_PRICELIST_ERROR]: (draft, action) => ({
      deliveryPriceList: {
        ...draft.deliveryPriceList,
        loading: false,
        error: action.payload.error,
      },
    }),
    [DELIVERY_PRICELIST_RESET]: () => ({
      deliveryPriceList: { ...initialState.deliveryPriceList },
    }),
    /// -----------------------CART CHECKOUT-----------------------///
    [DELIVERY_LIST_PROVIDERS]: (draft) => ({
      deliveryProvidersList: {
        ...draft.deliveryProvidersList,
        loading: true,
      },
    }),
    [DELIVERY_LIST_PROVIDERS_SUCCESS]: (draft, action) => ({
      deliveryProvidersList: {
        ...draft.deliveryProvidersList,
        loading: false,
        data: action.payload.data,
      },
    }),
    [DELIVERY_LIST_PROVIDERS_ERROR]: (draft, action) => ({
      deliveryProvidersList: {
        ...draft.deliveryProvidersList,
        loading: false,
        error: action.payload.error,
      },
    }),
    [DELIVERY_LIST_PROVIDERS_RESET]: () => ({
      deliveryProvidersList: { ...initialState.deliveryProvidersList },
    }),
  },
  initialState
);
